import Gettext from 'gettext.js';

const i18n = new Gettext({
    domain: 'messages', // Default domain
    locale: 'en',       // Default language
});

i18n.setMessages(
  "messages",
  "sk",
  {
      hide: "skryť",
      playlist: "zoznam",
      "highlights": ["highlighty", "highlightov"],
      part: "časť",
      parts: "časti",
      loading: "načítavanie",
      "Load more": "Načítať ďalšie",
      show: "zobraziť",
      "No videos": "Žiadne videá"
  },
    "nplurals=2; plural=n>4;"
);

export default i18n;